import { Plane, Users, MapPin, ArrowRight, Zap } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import StatusBadge from "@/components/StatusBadge";
import Countdown from "@/components/Countdown";
import { fmtLocal } from "@/lib/status";

function locName(loc) {
  if (!loc) return "—";
  return loc.iataCode || loc.establishment || loc.city || (loc.resolvedAddress || "").split(",")[0] || "—";
}

export default function JourneyCard({ journey, onOpen, onToggle }) {
  const j = journey;
  const done = ["COMPLETED", "CANCELLED_FREE", "CANCELLED_WITH_COSTS"].includes(j.status);

  return (
    <div
      data-testid={`journey-card-${j.journeyId}`}
      onClick={() => onOpen(j)}
      className="group cursor-pointer border border-zinc-800 bg-zinc-900/60 hover:bg-zinc-900 hover:border-zinc-700 rounded-md p-4 transition-colors animate-fade-up"
    >
      <div className="flex items-start justify-between gap-2 mb-3">
        <div>
          <div className="font-mono text-sm font-semibold text-zinc-200">{j.code}</div>
          <div className="font-mono text-[10px] text-blue-400/80 mt-0.5">ID: {j.journeyId}</div>
          <div className="text-[11px] text-zinc-500 mt-0.5">{fmtLocal(j.pickupLocalTime)}</div>
        </div>
        <StatusBadge status={j.status} />
      </div>

      <div className="flex items-center gap-2 text-sm mb-3">
        <MapPin className="h-3.5 w-3.5 text-zinc-500 shrink-0" />
        <span className="text-zinc-200 truncate max-w-[90px]">{locName(j.pickup)}</span>
        <ArrowRight className="h-3.5 w-3.5 text-zinc-600 shrink-0" />
        <span className="text-zinc-200 truncate max-w-[90px]">{locName(j.dropoff)}</span>
      </div>

      <div className="flex items-center gap-3 text-[12px] text-zinc-400 mb-3">
        {j.traveller?.flightNumber ? (
          <span className="flex items-center gap-1"><Plane className="h-3 w-3" />{j.traveller.flightNumber}</span>
        ) : null}
        <span className="flex items-center gap-1"><Users className="h-3 w-3" />{j.traveller?.passengerCount ?? "—"}</span>
        <span className="truncate text-zinc-500">
          {[j.traveller?.firstName, j.traveller?.lastName].filter(Boolean).join(" ") || "—"}
        </span>
      </div>

      <div className="flex items-center justify-between pt-3 border-t border-zinc-800">
        <div className="text-[11px]">
          {done ? (
            <span className="text-emerald-400 font-medium uppercase tracking-wide">Bitti</span>
          ) : j.nextStepLabel ? (
            <div>
              <div className="text-[10px] uppercase tracking-wider text-zinc-500">{j.nextStepLabel}</div>
              <Countdown target={j.nextActionAt} className="text-[13px] font-semibold" />
            </div>
          ) : (
            <span className="text-zinc-500">—</span>
          )}
        </div>
        <div className="flex items-center gap-1.5" onClick={(e) => e.stopPropagation()}>
          <Zap className={`h-3.5 w-3.5 ${j.automationEnabled ? "text-blue-400" : "text-zinc-600"}`} />
          <Switch
            data-testid={`journey-auto-${j.journeyId}`}
            checked={!!j.automationEnabled}
            onCheckedChange={(v) => onToggle(j, v)}
          />
        </div>
      </div>
    </div>
  );
}
